#import "../../../../common/graphql/EntityDocumentsFields.graphql"
query TravelAuthorizationApprovalHistoryItem($id: UUID!) {
  approvalHistoryItem(id: $id) {
    id
    id1
    trip {
         notesByEntityId {
            nodes {
              noteComment
            }
            totalCount
          }
          tripItems {
            nodes {
              tripSection {
                name
                layoutType
              }
              notesByEntityId {
                nodes {
                  noteComment
                }
                totalCount
              }
            }
          }
      travelAuthorization {
        __typename
        id
        documentFileId
        _rowTimestamp
        _isUpdatable
        _isDeletable
        _isOverBudget
        _isDistributionUpdateAllowed
        _isRevisable
        _isAccountingEntry
        _isHistory
        _isStampAllowed
        _isAccountingEntryStampedComplete
        _isTransactionCancelled
        _accountingStampDate
        _accountingStampUserName
        _accountingStampTransactionReference
        travelAuthorizationNumber
        tripPurpose
        comment
        travelAuthorizationDate
        bookingFee
        departmentId
        currencyId
        currency {
          isoCode
          name
          currencySymbol
        }
        statusType {
          statusType
          approvalState
          _transactionIconStatus
        }
        _suppliers
        isPersonalTravelAuthorization
        businessUnitId
        supplierId
        travelAuthorizationRevisionHistoriesByTaGroupId(
          orderBy: DATE_REQUESTED_DESC
          filter: { id: { notEqualTo: $id } }
        ) {
          nodes {
            id
            travelAuthorizationNumber
            travelPlan
            dateRequested
            taTotal
            tripPurpose
            requesterName
          }
        }
        supplier {
          id
          _fullName
          _isAliasOriginalNameViewable
          _isAliasInvoked
          _isUpdatable
          _isApproved
          supplierAddressesBySupplierId(orderBy: IS_PRIMARY_DESC, first: 1) {
            nodes {
              isPrimary
              addressLine1
              addressLine2
              cityName
              postalCode
              stateRegion {
                stateRegion
                country {
                  country
                }
                stateRegionDescription
              }
              telephoneNumber
              emailAddress
            }
          }
          vendorNumber
          vendorServiceRate
        }
        budgetAmount
        controlTotalAmount
        _isAirfareExist
        _airfareAmount
        _isAccommodationExist
        _accommodationAmount
        _isVehicleRentalExist
        _vehicleRentalAmount
        _isIncidentalExist
        _incidentalAmount
        _isTrainExist
        _trainAmount
        _isTransportationExist
        _transportationAmount
        trips(orderBy: TRIP_LOCATOR_ASC) {
          nodes {
            _requiredApprovalDocuments
            _isApprovalDocumentsRequired
            entityDocumentsByEntityId(
              orderBy: [
                DOCUMENT_POSITION_ASC
                _CREATED_DATE_DESC
                FILE_REFERENCE_ASC
              ]
            ) {
              nodes {
                ...EntityDocumentsFields
              }
              totalCount
            }
            tripHistoriesByEntityId {
              nodes {
                crudOperation
                pointInTimeDate
                tenantUserName
              }
            }
            notesByEntityId(orderBy: _CREATED_DATE_DESC) {
              nodes {
                id
                _createdByUserName
                _createdDate
                noteComment
                isShared
                _isUpdatable
                _rowTimestamp
                _isDeletable
              }
              totalCount
            }
            id
            _rowTimestamp
            tripLocator
            travelerReferenceName
            accountReference
            airfareAmount
            accommodationAmount
            transportationAmount
            vehicleRentalAmount
            trainAmount
            otherAmount
            controlTotalAmount
            _isOverBudget
            budgetAmount
            incidentalAmount
          }
        }
        notesByEntityId(orderBy: _CREATED_DATE_DESC) {
          nodes {
            id
            _createdByUserName
            _createdDate
            noteComment
            isShared
            _isUpdatable
            _rowTimestamp
            _isDeletable
          }
          totalCount
        }
        entityDocumentsByEntityId(
          orderBy: [
            DOCUMENT_POSITION_ASC
            _CREATED_DATE_DESC
            FILE_REFERENCE_ASC
          ]
        ) {
          nodes {
            ...EntityDocumentsFields
          }
          totalCount
        }
        travelAuthorizationHistoriesByEntityId {
          nodes {
            crudOperation
            pointInTimeDate
            tenantUserName
          }
        }
        entityTagsByEntityId {
          nodes {
            id
            _isDeletable
            _tagBadgeName
            _tagBadgeColor
            _createdDate
            createdByUser
            _rowTimestamp
          }
        }
        secureRowLevel {
          id
          name
          description
          securityLevel
        }
        _requiredApprovalDocuments
        _isProtected
        isDraft
        _isStagedApprovalRequest
        _isApprovalRevocable
        approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
          nodes {
            id
            requesterName
            requestedDate
            amount1
            currencyIsoCode
            isApprovalTreeViewerAllowed
            iconType {
              iconType
              iconState
            }
            statusType {
              statusType
            }
          }
        }
      }
    }
  }
}
